import React, { createContext, useContext, useState, useMemo, useCallback } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);
    const [cartOpen, setCartOpen] = useState(false);

    const addItem = useCallback((item) => {
        setCart(prev => {
            const existing = prev.find(i => i.variant_id === item.variant_id);
            if (existing) {
                return prev.map(i => i.variant_id === item.variant_id
                    ? { ...i, quantity: i.quantity + 1 }
                    : i
                );
            }
            return [...prev, { ...item, quantity: 1 }];
        });
        setCartOpen(true);
    }, []);

    const removeItem = useCallback((variant_id) => setCart(prev => prev.filter(i => i.variant_id !== variant_id)), []);

    const updateQty = useCallback((variant_id, qty) => {
        if (qty <= 0) { removeItem(variant_id); return; }
        setCart(prev => prev.map(i => i.variant_id === variant_id ? { ...i, quantity: qty } : i));
    }, [removeItem]);

    const clearCart = useCallback(() => setCart([]), []);

    const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const count = cart.reduce((sum, item) => sum + item.quantity, 0);

    const value = useMemo(
        () => ({ cart, cartOpen, setCartOpen, addItem, removeItem, updateQty, clearCart, total, count }),
        [cart, cartOpen, addItem, removeItem, updateQty, clearCart, total, count]
    );

    return (
        <CartContext.Provider value={value}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
